import { useDispatch, useSelector } from 'react-redux';
import StaleRecordsCard from '../StaleRecordsCard';
import { getOverviewStaleContacts } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '@/components/Dashboard/customHooks/useFetchDashboard';
import { useTrackOverviewTab } from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';
import UserIcon from '@/public/images/dashboard/user.svg';

export default function ContactsLastUpdate() {
  const dispatch = useDispatch();
  const { overviewStaleContacts } = useSelector(
    (state) => state.DashboardSlice
  );
  const track = useTrackOverviewTab();
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  const { loading, hasFetched } = overviewStaleContacts;

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewStaleContacts(query));
    },
    [],
    { hasFetched }
  );

  return (
    <StaleRecordsCard
      id="overview-contacts-last-update"
      ref={ref}
      loading={loading || isStale}
      data={overviewStaleContacts}
      icon={UserIcon}
      titleKey="ContactsLastUpdate"
      titleInfoTooltipKey="ContactsLastUpdateInfoTooltip"
      emptyStateTitleKey="HereYouWillSeeContactsWithoutRecentUpdates"
      trackShowAll={(element) => track.contactLastUpdate(element)}
      trackBar={() => track.contactLastUpdate(TRACK_ELEMENT.ROW)}
    />
  );
}
